/* Aflora Ritual — theme behaviour.
   Vanilla, no framework, no dependencies. Motion is short and calm: state
   changes 120ms, transitions 200ms, movement 360ms, no bounce, no spring. */
(function () {
  'use strict';

  /* Mirrors Liquid's money_without_trailing_zeros, so a price rewritten by JS
     reads exactly like the one the server rendered next to it. The separators
     are dictated by the placeholder in the shop's own money_format — this shop
     uses {{amount_with_comma_separator}}, which means period thousands and a
     comma decimal, NOT the other way round. Matching only one placeholder name
     is how the raw format string ends up on the page as "${{amount_...}}". */
  var money = function (cents) {
    var fmt = (window.AFLORA && window.AFLORA.moneyFormat) || '';
    var hole = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var name = hole ? hole[1] : 'amount';

    var thousands = ',';
    var decimal = '.';
    if (name.indexOf('comma_separator') !== -1) { thousands = '.'; decimal = ','; }
    else if (name.indexOf('apostrophe_separator') !== -1) { thousands = "'"; decimal = '.'; }
    else if (name.indexOf('period_and_space_separator') !== -1) { thousands = ' '; decimal = '.'; }
    else if (name.indexOf('space_separator') !== -1) { thousands = ' '; decimal = ','; }

    var value = (Number(cents) || 0) / 100;
    var str = name.indexOf('no_decimals') !== -1 ? String(Math.round(value)) : value.toFixed(2);
    var parts = str.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var out = parts[1] && parts[1] !== '00' ? parts[0] + decimal + parts[1] : parts[0];

    return hole ? fmt.replace(hole[0], out) : '$' + out;
  };

  var t = function (key, fallback) {
    return (window.AFLORA && window.AFLORA.strings && window.AFLORA.strings[key]) || fallback;
  };

  /* ── cart ─────────────────────────────────────────────────────────────── */
  var Cart = {
    add: async function (items) {
      var r = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!r.ok) { var e = await r.json().catch(function () { return {}; }); throw new Error(e.description || t('cart_error', 'No pudimos agregar el producto.')); }
      return r.json();
    },
    change: async function (line, quantity) {
      var r = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      return r.json();
    },
    get: async function () {
      var r = await fetch(window.Shopify.routes.root + 'cart.js');
      return r.json();
    },
    section: async function () {
      var r = await fetch(window.Shopify.routes.root + '?section_id=cart-drawer');
      return r.text();
    }
  };

  function announce(msg) {
    var live = document.getElementById('a-live');
    if (live) { live.textContent = ''; window.setTimeout(function () { live.textContent = msg; }, 30); }
  }

  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = '(' + n + ')';
    });
  }

  async function refreshDrawer(open) {
    var drawer = document.getElementById('a-cart-drawer');
    if (!drawer) return;
    try {
      var html = await Cart.section();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      /* The section render API returns the section alone — #shopify-section-cart-drawer.
         It never contains #a-cart-drawer, which is the wrapper in the layout, so looking
         for that here found nothing and the drawer silently kept whatever it rendered at
         page load: "Carrito (1)" sitting above an empty-cart message. Swap the section's
         contents and leave the wrapper, its scrim and its open state alone. */
      var next = doc.getElementById('shopify-section-cart-drawer');
      if (next) {
        var current = drawer.querySelector('#shopify-section-cart-drawer');
        if (current) {
          current.innerHTML = next.innerHTML;
        } else {
          var panel = drawer.querySelector('.a-drawer__panel');
          if (panel) panel.innerHTML = next.outerHTML;
        }
      }
      var cart = await Cart.get();
      setCartCount(cart.item_count);
    } catch (e) { /* drawer refresh is best-effort */ }
    if (open) openDrawer();
  }

  var lastFocus = null;
  function openDrawer() {
    var d = document.getElementById('a-cart-drawer');
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusable = d.querySelector('[data-drawer-close]');
    if (focusable) focusable.focus();
  }
  function closeDrawer() {
    var d = document.getElementById('a-cart-drawer');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (ev) {
    var openBtn = ev.target.closest('[data-drawer-open]');
    if (openBtn) { ev.preventDefault(); refreshDrawer(true); return; }

    if (ev.target.closest('[data-drawer-close]') || ev.target.closest('.a-drawer__scrim')) {
      ev.preventDefault(); closeDrawer(); return;
    }

    /* quick add / add to cart */
    var add = ev.target.closest('[data-add]');
    if (add) {
      ev.preventDefault();
      var id = add.getAttribute('data-add');
      var qtyInput = add.form ? add.form.querySelector('[data-qty-input]') : null;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var label = add.textContent;
      add.setAttribute('aria-busy', 'true');
      add.textContent = t('adding', 'Agregando');
      Cart.add([{ id: Number(id), quantity: qty }])
        .then(function () {
          announce(t('added', 'Agregado al carrito'));
          return refreshDrawer(true);
        })
        .catch(function (err) { announce(err.message); window.alert(err.message); })
        .finally(function () { add.removeAttribute('aria-busy'); add.textContent = label; });
      return;
    }

    /* line item quantity + remove inside the drawer */
    var lineBtn = ev.target.closest('[data-line-change]');
    if (lineBtn) {
      ev.preventDefault();
      var line = Number(lineBtn.getAttribute('data-line'));
      var q = Number(lineBtn.getAttribute('data-line-change'));
      lineBtn.setAttribute('aria-busy', 'true');
      Cart.change(line, q).then(function () { return refreshDrawer(false); });
      return;
    }

    /* mobile nav */
    var toggle = ev.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.getElementById('a-nav');
      if (nav) {
        var open = nav.classList.toggle('a-header__nav--open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) closeDisclosures();
      }
      return;
    }

    /* second-level nav. On desktop the panel also opens on hover, so this is
       the keyboard and touch path — and the one that pins it open. */
    var disc = ev.target.closest('[data-nav-disclosure]');
    if (disc) {
      ev.preventDefault();
      var wasOpen = disc.getAttribute('aria-expanded') === 'true';
      closeDisclosures();
      disc.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
      return;
    }

    /* a click anywhere else closes an open submenu */
    if (!ev.target.closest('.a-nav__panel')) closeDisclosures();
  });

  function closeDisclosures() {
    var open = document.querySelectorAll('[data-nav-disclosure][aria-expanded="true"]');
    for (var i = 0; i < open.length; i++) open[i].setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    closeDrawer();
    var focused = document.querySelector('.a-nav__group:focus-within [data-nav-disclosure]');
    closeDisclosures();
    if (focused && focused.focus) focused.focus();
  });

  /* ── quantity stepper ─────────────────────────────────────────────────── */
  document.addEventListener('click', function (ev) {
    var step = ev.target.closest('[data-qty-step]');
    if (!step) return;
    ev.preventDefault();
    var wrap = step.closest('.a-qty');
    var input = wrap && wrap.querySelector('[data-qty-input]');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var next = (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ── variant selection (PDP) ──────────────────────────────────────────── */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = document.getElementById(picker.getAttribute('data-form'));
    var data = JSON.parse(document.getElementById(picker.getAttribute('data-variants')).textContent);
    picker.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-variant-id]');
      if (!btn) return;
      var id = Number(btn.getAttribute('data-variant-id'));
      var variant = data.find(function (v) { return v.id === id; });
      if (!variant) return;
      picker.querySelectorAll('[data-variant-id]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      if (form) {
        var idField = form.querySelector('[name="id"]');
        if (idField) idField.value = id;
        var addBtn = form.querySelector('[data-add]');
        if (addBtn) {
          addBtn.setAttribute('data-add', id);
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? t('add_to_cart', 'Agregar al carrito') : t('sold_out', 'Agotado');
        }
      }
      document.querySelectorAll('[data-price-target]').forEach(function (el) {
        el.textContent = money(variant.price);
      });
      document.querySelectorAll('[data-sticky-price]').forEach(function (el) {
        el.textContent = money(variant.price);
      });
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url);
      }
    });
  });

  /* ── sticky add-to-cart on mobile PDP ─────────────────────────────────── */
  var sticky = document.querySelector('.a-sticky-atc');
  var anchor = document.querySelector('[data-atc-anchor]');
  if (sticky && anchor) {
    var lastSync = 0;
    var syncSticky = function () {
      lastSync = Date.now();
      sticky.classList.toggle('is-visible', anchor.getBoundingClientRect().bottom < 0);
    };
    /* Time-throttled rather than rAF-driven: rAF is suspended in background
       tabs, which would leave the bar in a stale state on return. */
    var onScroll = function () {
      if (Date.now() - lastSync < 100) return;
      syncSticky();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    syncSticky();
  }

  /* ── tabs ─────────────────────────────────────────────────────────────── */
  var selectTab = function (group, id) {
    group.querySelectorAll('[role=tab]').forEach(function (tab) {
      var on = tab.getAttribute('data-tab') === id;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.setAttribute('tabindex', on ? '0' : '-1');
    });
    group.querySelectorAll('[role=tabpanel]').forEach(function (panel) {
      panel.hidden = panel.id !== 'panel-' + id;
    });
  };

  document.addEventListener('click', function (ev) {
    var tab = ev.target.closest('[role=tab][data-tab]');
    if (!tab) return;
    var group = tab.closest('[data-tabs]');
    if (group) selectTab(group, tab.getAttribute('data-tab'));
  });

  /* Arrow keys move between tabs, per the WAI-ARIA tabs pattern. */
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'ArrowRight' && ev.key !== 'ArrowLeft') return;
    var tab = ev.target.closest && ev.target.closest('[role=tab][data-tab]');
    if (!tab) return;
    var group = tab.closest('[data-tabs]');
    if (!group) return;
    var tabs = [].slice.call(group.querySelectorAll('[role=tab]'));
    var next = tabs[(tabs.indexOf(tab) + (ev.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
    selectTab(group, next.getAttribute('data-tab'));
    next.focus();
    ev.preventDefault();
  });

  /* ── collection filter (family / sort) — plain form, no JS required ───── */
  document.querySelectorAll('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });

  /* ── carrusel ───────────────────────────────────────────────────────────
     La vía se arrastra sin JS; las flechas son el extra. Nacen con [hidden] y
     sólo se muestran acá, así que sin JS nadie ve un botón que no responde.
     Se ocultan otra vez si todo entra en pantalla — una flecha que no lleva a
     ningún lado enseña a ignorar las flechas. */
  document.querySelectorAll('[data-rail]').forEach(function (rail) {
    var nav = rail.parentNode.querySelector('[data-rail-nav]');
    if (!nav) return;
    var prev = nav.querySelector('[data-rail-prev]');
    var next = nav.querySelector('[data-rail-next]');

    function step() {
      var card = rail.firstElementChild;
      if (!card) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      /* Avanza por páginas enteras de tarjetas, nunca dejando una a medias. */
      var unit = card.getBoundingClientRect().width + gap;
      var perPage = Math.max(1, Math.floor((rail.clientWidth + gap) / unit));
      return unit * perPage;
    }

    function sync() {
      var scrollable = rail.scrollWidth - rail.clientWidth > 1;
      nav.hidden = !scrollable;
      if (!scrollable) return;
      var max = rail.scrollWidth - rail.clientWidth;
      prev.disabled = rail.scrollLeft <= 1;
      next.disabled = rail.scrollLeft >= max - 1;
    }

    function go(dir) {
      /* Asignación directa: la animación la pone `scroll-behavior:smooth` del
         CSS, que ya respeta prefers-reduced-motion. Un solo mecanismo — con
         scrollTo({behavior:'smooth'}) el clic se pierde en los navegadores que
         no lo honran dentro de un contenedor. */
      var max = rail.scrollWidth - rail.clientWidth;
      rail.scrollLeft = Math.max(0, Math.min(max, rail.scrollLeft + dir * step()));
      /* El evento `scroll` llega un cuadro después; sin esto, dos clics seguidos
         encuentran el botón todavía deshabilitado y el segundo se pierde. */
      sync();
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (window.ResizeObserver) new ResizeObserver(sync).observe(rail);
    sync();
  });

  /* ── galería de producto ────────────────────────────────────────────────
     El carrusel ya funciona solo (es el mismo `[data-rail]`); esto sólo
     conecta las miniaturas y marca cuál se está viendo. Sin JS quedan las
     miniaturas como enlaces internos y el arrastre nativo. */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var rail = gal.querySelector('[data-rail]');
    var thumbs = gal.querySelectorAll('[data-gallery-thumb]');
    if (!rail || !thumbs.length) return;

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var slide = rail.children[parseInt(btn.getAttribute('data-gallery-thumb'), 10)];
        if (slide) rail.scrollLeft = slide.offsetLeft - rail.offsetLeft;
      });
    });

    var mark = function () {
      var unit = rail.clientWidth || 1;
      var i = Math.round(rail.scrollLeft / unit);
      thumbs.forEach(function (b, n) {
        b.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    };
    rail.addEventListener('scroll', mark, { passive: true });
    mark();
  });
})();
